import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { AdvisorEngineContactSyncSettings } from './AdvisorEngineContactSyncSettings'
import { AdvisorEngineContactCreateSettings } from './AdvisorEngineContactCreateSettings'

export const AdvisorEngineSpecificSettings = (): ClickNavigationSection[] => {
  return [
    { id: 'contactSync', label: 'Contact Sync', content: () => <AdvisorEngineContactSyncSettings /> },
    { id: 'contactCreate', label: 'Contact Create', content: () => <AdvisorEngineContactCreateSettings /> },
    { id: 'task', label: 'Task', content: () => <CRMIntegrationTaskSettings serviceId={IntegrationServiceId.ADVISOR_ENGINE} /> },
  ]
}
